import { useState } from "react";
import { ShieldCheck, FileText, Sparkles } from "lucide-react";
import AcceptTerms from "../AcceptTerms";

export function MemberLoginScreen({ onLogin }) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  return (
    <div className="max-w-3xl mx-auto px-6 pt-24 pb-24 text-center" data-testid="member-login-screen">
      <div className="overline text-[var(--red)] mb-4">Grant Partnership</div>
      <h1 className="font-display font-semibold text-4xl sm:text-5xl tracking-tight mb-6">
        AI-powered grant tools, <span className="text-[var(--red)]">on your team.</span>
      </h1>
      <p className="text-lg text-[var(--text-2)] mb-10 max-w-xl mx-auto">
        Sign in to access the Bid Readiness Scorer, the AI Grant Writer, and our Capability Statement —
        available exclusively to Grant Partnership members.
      </p>
      <div className="grid sm:grid-cols-3 gap-4 mb-12 text-left">
        {[
          { icon: ShieldCheck, label: "Bid Readiness Scorer", desc: "Score any RFP against your org in seconds." },
          { icon: Sparkles, label: "AI Grant Writer", desc: "Compile funder-ready proposal drafts." },
          { icon: FileText, label: "Capability Statement", desc: "On-demand, always up to date." },
        ].map((f) => (
          <div key={f.label} className="card-dark p-5">
            <f.icon className="w-5 h-5 text-[var(--red)] mb-3" />
            <div className="font-medium text-white text-sm mb-1">{f.label}</div>
            <div className="text-xs text-[var(--text-2)]">{f.desc}</div>
          </div>
        ))}
      </div>
      <div className="max-w-lg mx-auto mb-6 text-left">
        <AcceptTerms checked={acceptedTerms} onChange={setAcceptedTerms} testId="member-accept-terms" />
      </div>
      <button onClick={onLogin} disabled={!acceptedTerms} className="btn-red disabled:opacity-50 disabled:cursor-not-allowed" data-testid="member-google-signin-btn">
        Sign in with Google
      </button>
    </div>
  );
}
